export default {"title":"react-json-friendly-viewer"};